import React from "react";
import { Spin as AntdSpin } from "antd";
import type { SpinProps as AntdSpinProps } from "antd";
import V2Spinner from "./V2Spinner";

export type SpinProps = AntdSpinProps & {
};

/**
 * Spin component - loading indicator with custom V2 spinner
 * Automatically uses the V2 custom spinner unless a custom indicator is provided
 */
const Spin: React.FC<SpinProps> = ({ indicator, ...props }) => {
  // Use V2Spinner as default indicator if none is provided
  const defaultIndicator = indicator ?? <V2Spinner />;

  return <AntdSpin indicator={defaultIndicator} {...props} />;
};

export default Spin;
